import { useItsmeQrAuthenticationFlow } from '../../hooks/useItsmeQrAuthenticationFlow';
import { useScreen } from '../useScreen';

interface ViewProps {
    expired: boolean;
    authenticating: boolean;
    authenticated: boolean;
    qrCode: string | null;
    error: string | null;
}

const useItsmeQrAuthentication = (): ViewProps => {
    const { onSubmit: onContinue } = useScreen();

    return useItsmeQrAuthenticationFlow({
        id: 'itsme-qr-authentication',
        onUserAuthenticated: () => {
            onContinue();
        }
    });
};

export default useItsmeQrAuthentication;
